import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
function errorMessage(error, fallback) {
  var errors = error && error.response && error.response.errors ? error.response.errors : error && error.errors ? error.errors : null;
  if (errors && errors.length) {
    return errors[0].detail || errors[0].title || fallback;
  }
  return error && error.message || fallback;
}
function replyCount(discussion) {
  if (!discussion || !discussion.commentCount) return 0;
  var count = parseInt(discussion.commentCount(), 10);
  if (!Number.isFinite(count)) return 0;
  return Math.max(0, count - 1);
}
export default class ReminderModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.recital = this.attrs.recital;
    this.discussion = this.attrs.discussion;
    this.contentValue = '';
    this.loadingCount = true;
    this.saving = false;
    this.error = null;
    this.loadSubmissionCount();
  }
  className() {
    return 'RecitalReminderModal Modal--large';
  }
  title() {
    return app.translator.trans('pianotell-recitals.forum.reminder_modal_title');
  }
  content() {
    return m('.Modal-body', [m('form', {
      onsubmit: e => {
        e.preventDefault();
        this.submit();
      }
    }, [m('.Form-group', [m('label', app.translator.trans('pianotell-recitals.forum.reminder_content_label')), m('textarea.FormControl.RecitalReminderModal-content', {
      rows: 8,
      disabled: this.loadingCount || this.saving,
      value: this.contentValue,
      oninput: e => {
        this.contentValue = e.target.value;
      }
    }), m('.helpText', this.loadingCount ? app.translator.trans('pianotell-recitals.forum.reminder_loading_count') : app.translator.trans('pianotell-recitals.forum.reminder_content_help'))]), this.error ? m('.Alert.Alert--error', this.error) : null, m('.Form-group', {
      style: 'text-align: right;'
    }, [Button.component({
      className: 'Button Button--primary RecitalReminderModal-submit',
      type: 'submit',
      loading: this.saving,
      disabled: this.saving || this.loadingCount || !String(this.contentValue || '').trim()
    }, app.translator.trans('pianotell-recitals.forum.reminder_submit'))])])]);
  }
  loadSubmissionCount() {
    var submissionDiscussionId = this.recital && this.recital.submissionDiscussionId ? this.recital.submissionDiscussionId() : null;
    var apiUrl = app.forum.attribute('apiUrl');
    var discussionId = this.discussion && this.discussion.id ? this.discussion.id() : null;
    if (!discussionId) {
      this.setTemplate(0, '');
      return;
    }

    // Fetch the live submission list (server-side, coordinator-only) so the
    // reminder is prefilled with the current performers, not just a count.
    fetch(apiUrl + '/recitals/reminder-list', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': app.session.csrfToken
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        discussionId: parseInt(discussionId, 10)
      })
    }).then(r => r.json()).then(result => {
      this.setTemplate(result && result.count != null ? result.count : 0, result && result.list || '');
      m.redraw();
    }).catch(() => {
      // Fall back to the store-based count if the endpoint is unavailable.
      var loaded = submissionDiscussionId && app.store && app.store.getById ? app.store.getById('discussions', String(submissionDiscussionId)) : null;
      this.setTemplate(loaded && loaded.commentCount ? replyCount(loaded) : 0, '');
      m.redraw();
    });
  }
  setTemplate(count, list) {
    this.loadingCount = false;
    var key = list && String(list).trim() ? 'pianotell-recitals.forum.reminder_template_with_list' : 'pianotell-recitals.forum.reminder_template';
    this.contentValue = extractText(app.translator.trans(key, {
      count,
      list: list || ''
    }));
  }
  submit() {
    if (this.saving || this.loadingCount) return;
    var content = String(this.contentValue || '').trim();
    if (!content) return;
    this.saving = true;
    this.error = null;
    app.store.createRecord('posts').save({
      content,
      relationships: {
        discussion: this.discussion
      }
    }).then(post => {
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('pianotell-recitals.forum.reminder_success'));
      this.hide();
      if (app.viewingDiscussion && app.viewingDiscussion(this.discussion) && app.current && app.current.get) {
        var stream = app.current.get('stream');
        if (stream && stream.update) {
          stream.update().then(() => {
            if (stream.goToNumber && post && post.number) stream.goToNumber(post.number());
          });
        }
      }
      m.redraw();
    }).catch(error => {
      this.saving = false;
      this.error = errorMessage(error, app.translator.trans('pianotell-recitals.forum.reminder_error'));
      app.alerts.show({
        type: 'error'
      }, this.error);
      m.redraw();
    });
  }
}
flarum.reg.add('pianotell-recitals', 'forum/components/ReminderModal', ReminderModal);